/**
 * NotFoundView — rendered for any hash that doesn't match one of the
 * six known routes. Always reachable; provides a back-to-daily action.
 */

import { el } from "../dom";
import { navigate } from "../router";

export function renderNotFoundView(): HTMLElement {
  return el("section", { class: "view view-not-found", "data-view": "not-found" }, [
    el("div", { class: "view-title" }, [
      el("h1", null, "404"),
      el("p", { class: "view-title-sub" }, "页面不存在"),
    ]),
    el("div", { class: "placeholder-view" }, [
      el("p", null, "您访问的页面不存在或已被移动。"),
      el("p", null, [
        el("a", {
          href: "#/daily",
          onclick: (ev: Event) => {
            const me = ev as MouseEvent;
            if (me.metaKey || me.ctrlKey || me.button !== 0) return;
            ev.preventDefault();
            navigate("/daily");
          },
        }, "返回每日文献动态"),
      ]),
    ]),
  ]);
}
